import { render, staticRenderFns } from "./PersonalPhoto.vue?vue&type=template&id=ba855aae&"
import script from "./PersonalPhoto.vue?vue&type=script&lang=js&"
export * from "./PersonalPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports